import FavoriteAnswer from 'models/favorite_answer';

export default {
  fromDto(dto) {
    return FavoriteAnswer.fromJs({ ...dto, id: dto.answerId });
  },

  toDto(entity) {
    return entity.toJs();
  },
};
